module.exports = __webpack_public_path__ + "static/media/FlechaPassaPagina.58749b00.svg";